module.exports = __webpack_public_path__ + "static/media/18ECA4.21522934.jpg";